export default "<div class=\"alert bg-{{typeAlert}}\">\r\n    <p>\r\n        <ng-content></ng-content>\r\n    </p>\r\n</div>"